import { Link, useNavigate } from 'react-router-dom';
import { AnimeGrid } from '@/components/anime/AnimeGrid';
import { GenreChips } from '@/components/anime/GenreChips';
import { HeroSpotlight } from '@/components/anime/HeroSpotlight';
import { LatestEpisodes } from '@/components/anime/LatestEpisodes';
import { StatsStrip } from '@/components/anime/StatsStrip';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { HOME_EPISODE_SIZE, HOME_RAIL_SIZE } from '@/lib/constants';
import { useAnimeList, useGenres } from '@/hooks/useAnimeQueries';

const viewAllClass =
	'text-[13px] font-bold text-accent transition hover:translate-x-0.5 hover:text-ink';

export function HomePage() {
	const navigate = useNavigate();

	const popularQuery = useAnimeList({
		sortField: '_id',
		sortType: 'desc',
		limit: HOME_RAIL_SIZE + 1,
	});
	const latestQuery = useAnimeList({
		sortField: 'modified.time',
		sortType: 'desc',
		limit: HOME_EPISODE_SIZE,
	});
	const genresQuery = useGenres();

	const popularItems = popularQuery.data?.items ?? [];
	const spotlight = popularItems[0];

	return (
		<>
			<HeroSpotlight anime={spotlight} isLoading={popularQuery.isPending} />

			<section className="mt-10">
				<SectionHeader
					title="Mới thêm vào kho"
					action={
						<Link to="/duyet?sort=_id-desc" className={viewAllClass}>
							Xem tất cả →
						</Link>
					}
				/>
				<AnimeGrid
					items={popularItems.slice(1)}
					isLoading={popularQuery.isPending}
					error={popularQuery.error}
					onRetry={() => void popularQuery.refetch()}
					skeletonCount={HOME_RAIL_SIZE}
				/>
			</section>

			<section className="mt-10">
				<SectionHeader
					title="Tập mới cập nhật"
					action={
						<Link to="/duyet" className={viewAllClass}>
							Tất cả bản mới →
						</Link>
					}
				/>
				<LatestEpisodes
					items={latestQuery.data?.items ?? []}
					isLoading={latestQuery.isPending}
					error={latestQuery.error}
					onRetry={() => void latestQuery.refetch()}
				/>
			</section>

			<section className="mt-10">
				<SectionHeader
					title="Khám phá thể loại"
					action={
						<Link to="/the-loai" className={viewAllClass}>
							Tất cả thể loại →
						</Link>
					}
				/>
				<GenreChips
					genres={genresQuery.data ?? []}
					isLoading={genresQuery.isPending}
					activeSlug=""
					includeAllOption={false}
					onSelect={(slug) => navigate(`/duyet?category=${slug}`)}
				/>
			</section>

			<StatsStrip
				totalTitles={popularQuery.data?.pagination.totalItems ?? 0}
				totalGenres={genresQuery.data?.length ?? 0}
			/>
		</>
	);
}
